export const getSHA256Hash = async (input: string): Promise<string> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    let hashBuffer;

    if (typeof window === 'undefined') {
        hashBuffer = await global.crypto.subtle.digest('SHA-256', data);
    } else {
        hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    }

    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashString = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashString;
};
